import { connect } from 'react-redux';
import { updateAccounts } from 'actions/partner';
import AccountsFilter from 'components/filters/AccountsFilter';
import { getCohorts, getSubgroups, getLoaders } from 'selectors';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    meta: state.meta.accounts,
    cohorts: getCohorts(state),
    subgroups: getSubgroups(state),
    groups: state.filters.groups,
    partners: state.filters.partners,
    withScope: state.filters.withScope,
    isLoading: getLoaders(state, ['ACCOUNTS', 'DASHBOARD_FILTER']),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onArchivedChange: (value) => {
      dispatch(updateAccounts({archived: value, page: 1}))
    },
    onSubgroupChange: (subgroups) => {
      dispatch(updateAccounts({subgroups, page: 1}));
    },
    onCohortChange: (cohorts) => {
      dispatch(updateAccounts({cohorts, page: 1}));
    },
    onGroupChange: (groups) => {
      dispatch(updateAccounts({groups, page: 1}))
    },
    onPartnerChange: (partners) => {
      dispatch(updateAccounts({partners, page: 1}))
    },
    onSearch: (q) => {
      dispatch(updateAccounts({q, page: 1}))
    },
  }
}

const AccountsFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountsFilter)

export default AccountsFilterContainer;
